// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__3AKSa","question":"Question_question__3Zqqz","description":"Question_description__GkHCP"};